var exports = {
  "container": "x43cbe9c2--47245b--container",
  "sale": "x43cbe9c2--47245b--sale",
  "textblock": "x43cbe9c2--47245b--textblock",
  "rent": "x43cbe9c2--47245b--rent",
  "host": "x43cbe9c2--47245b--host",
  "title": "x43cbe9c2--47245b--title",
  "btn": "x43cbe9c2--47245b--btn",
  "image": "x43cbe9c2--47245b--image",
  "town": "x43cbe9c2--47245b--town",
  "house": "x43cbe9c2--47245b--house",
  "apart": "x43cbe9c2--47245b--apart",
  "tablet": "x43cbe9c2--47245b--tablet",
  "phone": "x43cbe9c2--47245b--phone",
};

module.exports = exports;
